export default "__VITE_ASSET__ccf81339__"